import React, { useEffect, useState } from "react";
import DynamicActionBar from "../../Common/DynamicActionBar";
import { ChevronRight } from "lucide-react";
import { Modal } from "../../Common/Modal";
import OptionBox from "../../Common/OptionBox";
import { Divider } from "@mui/material";
import DynamicTabs from "../../Common/DynamicTabs";
import DynamicBoxGrid from "../../Common/DynamicBoxGrid";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../../redux/actions";
import { ErrorToast } from "../../Common/Toast";
import {
  getlocalStorage,
  setlocalStorage,
} from "../../Service/api/configuration/localstorage";
import { HeadersPath, path } from "../../Utils/ScreenPath";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { Api } from "../../Service/api";

const SectionPaper = ({ paper_type, genrate_type }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = getlocalStorage("userData");
  const boardDataList = useSelector((state) => state?.Board?.BoardData || {});
  const mediumDataList = useSelector(
    (state) => state?.Medium?.MediumData || {}
  );
  const standardDataList = useSelector(
    (state) => state?.Standard?.StandardData || {}
  );
  const semesterDataList = useSelector(
    (state) => state?.Semester?.SemesterData || {}
  );
  const subjectDataList = useSelector(
    (state) => state?.Subject?.SubjectData || {}
  );
  const GetUser = useSelector((state) => state?.GetUser?.GetUserData || {});
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);

  const [boardData, setBoardData] = useState([]);
  const [mediumData, setMediumData] = useState([]);
  const [standardData, setStandardData] = useState([]);
  const [semesterData, setSemesterData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [isModelOpen, setisModelOpen] = useState(false);
  const [labelName, setLabelName] = useState("");
  const [modelData, setModelData] = useState({});
  const handleBackClick = () => { };

  const handleModelOpen = () => {
    setisModelOpen(!isModelOpen);
  };

  const handleModelClose = () => {
    setisModelOpen(!isModelOpen);
  };

  const actions = [
    {
      icon: <ChevronRight style={{ width: "20px", height: "20px" }} />,
      roundedButton: true,
      onClick: handleModelOpen,
    },
  ];

  const handleGetBoard = async () => {
    try {
      let params = {
        isOthers: true,
      };
      dispatch(ACTIONS.getBoardData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      // set loader false
    }
  };

  useEffect(() => {
    if (GetUser?.status === 200) {
      setlocalStorage("userData", GetUser?.data?.userInfo);
    }
  }, [GetUser]);

  const handleGetUserData = async () => {
    try {
      let params = {
        id: userData?.user_id,
      };
      dispatch(ACTIONS.GetUserAction(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      // set loader false
    }
  };

  const handleGetMedium = async () => {
    try {
      let params = {
        board: selectedData?.board,
        isOthers: true,
      };
      dispatch(ACTIONS.getMediumData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      // set loader false
    }
  };

  const handleGetStandard = async () => {
    try {
      let params = {
        medium: selectedData?.medium,
        isManual: true,
        isLearn: false,
      };
      dispatch(ACTIONS.getStandardData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      // set loader false
    }
  };

  const handleGetSemester = async () => {
    try {
      let params = {
        standard: selectedData?.standard_id,
        isManual: true,
        isLearn: false,
      };
      dispatch(ACTIONS.getSemesterData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      // set loader false
    }
  };

  const handleGetSubject = async (semesterId) => {
    try {
      let params = {
        semester: semesterId?.id || selectedData?.semester_id,
        standard: modelData?.standard_id || selectedData?.standard_id,
        semister: selectedData?.semester_id,
        medium_id: selectedData?.medium,
        isManual: true,
        isLearn: false,
        limit: 1000,
        Offset: 1,
      };
      dispatch(ACTIONS.getSubjectData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      // set loader false
    }
  };

  const handleUpdateProfile = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        id: userData?.user_id,
        data: JSON.stringify({
          board_id: selectedData?.board,
          medium_id: selectedData?.medium,
          standard_id: modelData?.standard_id,
        }),
      };
      const { data } = await Api.UpdateProfile(body);
      const res = JSON.parse(data);
      if (res?.status === 200) {
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handleModelapply = () => {
    handleUpdateProfile();
    setisModelOpen(!isModelOpen);
    handleGetSemester();
    handleGetSubject();
    dispatch(ACTIONS.getSelectedData(modelData));
    setLabelName(
      `${mediumData?.data?.find((medium) => medium?.id === selectedData?.medium)
        ?.name
      }(${standardData?.data?.find(
        (standard) => standard?.id == modelData?.standard_id
      )?.name
      })`
    );
  };

  const handleSubjectClick = (subject) => { };

  const handleDataClick = (name, value) => {
    if (selectedData?.[name] === value?.id) {
      return;
    }
    if (name === "board") {
      let payload = {
        ...selectedData,
        medium: "",
        standard_id: "",
        standard_name: "",
        [name]: value?.id,
      };
      setModelData({});
      dispatch(ACTIONS.getSelectedData(payload));
      setMediumData([]);
      setStandardData([]);
    }

    if (name === "medium") {
      let payload = {
        ...selectedData,
        standard_id: "",
        standard_name: "",
        [name]: value?.id,
      };
      setModelData({});
      dispatch(ACTIONS.getSelectedData(payload));
      setStandardData([]);
    }

    if (name === "standard_id") {
      let payload = {
        ...selectedData,
        [name]: value?.id,
        standard_name: value?.name,
      };
      setModelData(payload);
    }

    if (name === "semester_id") {
      let payload = {
        ...selectedData,
        subject_id: "",
        subject_name: "",
        [name]: value?.id,
        semester_name: value?.semester,
      };
      dispatch(ACTIONS.getSelectedData(payload));
      handleGetSubject(value);
    }

    if (name === "subject_id") {
      let payload = {
        exam_date: moment(new Date()).format("DD/MM/YYYY"),
        genrate_type: genrate_type,
        paper_type: paper_type,
        board: selectedData?.board,
        medium: selectedData?.medium,
        semester_id: selectedData?.semester_id,
        semester_name: selectedData?.semester_name,
        standard_id: selectedData?.standard_id,
        standard_name: selectedData?.standard_name,
        template_name: "",
        sections_info: [
          {
            section_name: "Section A",
            section_id: 1,
            divisions: [
              {
                marks: 0,
                random_genrate_notice: "",
                division_id: 1,
                question_data: [],
              },
            ],
          },
        ],
        [name]: value?.id,
        subject_name: value?.subject,
      };
      dispatch(ACTIONS.getSelectedData(payload));
      navigate(path.ManuallyGenerate + `/${false}`);
    }
  };

  useEffect(() => {
    if (boardDataList?.status === 200) {
      setBoardData(boardDataList);
    }
  }, [boardDataList]);

  useEffect(() => {
    // if(mediumDataList?.status === 200){
    setMediumData(mediumDataList);
    // }
  }, [mediumDataList]);

  useEffect(() => {
    if (standardDataList?.status === 200) {
      setStandardData(standardDataList);
    }
  }, [standardDataList]);

  useEffect(() => {
    if (semesterDataList?.status === 200) {
      setSemesterData(semesterDataList);
    }
  }, [semesterDataList]);

  useEffect(() => {
    if (subjectDataList?.status === 200) {
      setSubjectData(subjectDataList);
    }
  }, [subjectDataList]);

  useEffect(() => {
    if (userData?.boardInfo?.id) {
      let payload = {
        ...selectedData,
        paper_type: paper_type,
        genrate_type: genrate_type,
        board: userData?.boardInfo?.id,
        medium: userData?.mediumInfo?.id,
        standard_id: userData?.standardInfo?.id,
        standard_name: userData?.standardInfo?.name,
      };
      setModelData({
        ...modelData,
        standard_id: userData?.standardInfo?.id,
        standard_name: userData?.standardInfo?.name,
      });
      dispatch(ACTIONS.getSelectedData(payload));
      handleGetBoard();
      setLabelName(
        `${userData?.mediumInfo?.name}(${userData?.standardInfo?.label})`
      );
    }
    handleGetUserData();
    dispatch(
      ACTIONS.getHeaderPath(
        genrate_type == "with section"
          ? HeadersPath.SectionWise
          : HeadersPath.withoutSection
      )
    );
  }, []);

  useEffect(() => {
    if (selectedData?.board) {
      handleGetMedium();
    }
  }, [selectedData?.board]);

  useEffect(() => {
    if (selectedData?.medium) {
      handleGetStandard();
    }
  }, [selectedData?.medium]);

  useEffect(() => {
    if (selectedData?.standard_id) {
      handleGetSemester();
    }
  }, [selectedData?.standard_id]);

  useEffect(() => {
    if (selectedData?.semester_id) {
      handleGetSubject();
    }
  }, [selectedData?.semester_id]);

  return (
    <div>
      <DynamicActionBar
        backButtonLabel={labelName}
        onBackClick={handleBackClick}
        actions={actions}
      />

      <Modal
        title="Edit Paper"
        buttonText="Apply"
        width="max-w-2xl"
        modalOpen={isModelOpen}
        disabled={
          !selectedData?.board ||
          !selectedData?.medium ||
          !modelData?.standard_id
        }
        onApply={handleModelapply}
        onClose={handleModelClose}
      >
        <div>
          <div className="space-y-4">
            {boardData?.data?.length > 0 && (
              <div>
                <h3 className="font-semibold mb-2">Board</h3>
                <div className="flex flex-wrap gap-2">
                  {boardData?.data?.map((board) => (
                    <OptionBox
                      selected={board?.id === selectedData?.board}
                      onClick={() => handleDataClick("board", board)}
                    >
                      {board?.board_name}
                    </OptionBox>
                  ))}
                </div>
                <Divider style={{ marginTop: "10px" }} />
              </div>
            )}
            {mediumData?.data?.length > 0 && (
              <div>
                <h3 className="font-semibold mb-2">Medium</h3>
                <div className="flex flex-wrap gap-2">
                  {mediumData?.data?.map((medium) => (
                    <OptionBox
                      selected={medium?.id === selectedData?.medium}
                      onClick={() => handleDataClick("medium", medium)}
                    >
                      {medium?.name}
                    </OptionBox>
                  ))}
                </div>
                <Divider style={{ marginTop: "10px" }} />
              </div>
            )}
            {standardData?.data?.length > 0 && (
              <div>
                <h3 className="font-semibold mb-2">Standard</h3>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                  {standardData?.data?.map((standard) => (
                    <OptionBox
                      selected={standard?.id === modelData?.standard_id}
                      onClick={() => handleDataClick("standard_id", standard)}
                    >
                      {standard?.name}
                    </OptionBox>
                  ))}
                </div>
                <Divider style={{ marginTop: "10px" }} />
              </div>
            )}
          </div>
        </div>
      </Modal>

      <div
        style={{
          position: "sticky",
          top: "69px",
          zIndex: "1",
          backgroundColor: "white",
        }}
      >
        <DynamicTabs tabs={semesterData} onTabChange={handleDataClick} />
      </div>

      <div>
        <DynamicBoxGrid
          subjects={subjectData?.data}
          onSubjectClick={handleDataClick}
        />
      </div>
    </div>
  );
};

export default SectionPaper;
